(function () {
  var modal = document.getElementById('QuoteRequestModal');
  if (!modal) return;

  var productField = modal.querySelector('[data-quote-modal-product]');
  var subtitle = modal.querySelector('[data-quote-modal-subtitle]');
  var phoneInput = modal.querySelector('[data-phone-local]');
  var form = modal.querySelector('#QuoteRequestForm');
  var lastFocusedElement = null;

  function openModal(title, sku) {
    var productLabel = sku ? title + ' | SKU: ' + sku : title;
    if (productField) productField.value = productLabel;
    if (subtitle) {
      subtitle.innerHTML = '';
      var titleSpan = document.createElement('span');
      titleSpan.textContent = title;
      subtitle.appendChild(titleSpan);
      if (sku) {
        var skuSpan = document.createElement('span');
        skuSpan.className = 'quote-modal__sku';
        skuSpan.textContent = ' | SKU: ' + sku;
        subtitle.appendChild(skuSpan);
      }
    }

    lastFocusedElement = document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';

    var firstInput = modal.querySelector('#QuoteRequestForm-name');
    if (firstInput) firstInput.focus();
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    if (lastFocusedElement) lastFocusedElement.focus();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quote-trigger]');
    if (trigger) {
      openModal(trigger.getAttribute('data-quote-title') || '', trigger.getAttribute('data-quote-sku') || '');
      return;
    }
    if (event.target.closest('[data-quote-modal-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });

  if (phoneInput) {
    phoneInput.addEventListener('input', function () {
      phoneInput.value = phoneInput.value.replace(/\D/g, '').slice(0, 10);
    });
  }

  if (form) {
    form.addEventListener('submit', function () {
      if (phoneInput) {
        var digits = phoneInput.value.replace(/\D/g, '');
        phoneInput.value = digits ? '+91' + digits : '';
      }
    });
  }
})();
